export default ['name', 'override', 'required', 'size', 'variant'];
